import Gateway from 'api/types/Gateway';
import { GatewayResponse } from 'api/types/types';
import { ISubmitValues } from 'entities/submission';

export default abstract class ISubmissionGateway extends Gateway {
    abstract submit(params: ISubmitValues): GatewayResponse<string>;
}
